<p-toast key="manage-user-message" position="top-right"></p-toast>

<!--Basic Details Dialog on Add New User-->
<p-dialog [(visible)]="displayBasicDetailsDialog" [blockScroll]="true" [modal]="true" class="basic-details-dialog"
          [showHeader]="false"
          [closable]="false"
          [closeOnEscape]="false"
          [draggable]="false"
          [breakpoints]="{'1440px': '50%' ,'1024px': '50%','960px': '50%', '640px': '90%'}"
          [style]="{width: '35%'}">


    <!--Heading-->
    <div class="p-grid p-mt-2">
        <div class="p-col-12">
            <h5 class="p-text-primary p-m-0">Enter Basic Details</h5>
        </div>
    </div>

    <!--User Basic Details Form-->

    <div [formGroup]="userBasicDetailsForm">
        <div class="p-grid p-mt-2">

            <div class="p-col-12">
                <div class="p-field">
                    <div>
                        <small>
                            Username *
                        </small>
                        <small *ngIf="userBasicDetailsForm.get('username').invalid && userBasicDetailsForm.get('username').touched"
                               class="p-text-danger">Enter valid email</small>
                    </div>
                    <input [class.is-invalid]="userBasicDetailsForm.get('username').invalid && userBasicDetailsForm.get('username').touched"
                           formControlName="username"
                           pInputText placeholder="Must be and Email Address" type="email"
                           class="width-100">
                </div>
            </div>

            <div class="p-col-12">
                <div class="p-field">
                    <small>
                        Roles *
                    </small>
                    <p-multiSelect styleClass="width-100"
                                   appendTo="body"
                                   [options]="roles"
                                   formControlName="roles"
                                   emptyMessage="No Roles Found"
                                   filterBy="name"
                                   emptyFilterMessage="No Roles Found"
                                   optionLabel="name" optionValue="name"
                    ></p-multiSelect>
                </div>
            </div>

            <div class="p-col-12">
                <div class="p-field">
                    <small>
                        Password *
                    </small>
                    <p-password [toggleMask]="true" formControlName="password" class="password-input"
                                styleClass="width-100"
                    ></p-password>
                </div>
            </div>

            <div class="p-col-12">
                <div class="p-field">
                    <small>
                        Confirm Password *
                    </small>
                    <p-password [toggleMask]="true" [(ngModel)]="confirmPassword" [ngModelOptions]="{standalone: true}"
                                class="password-input"
                                styleClass="width-100"></p-password>
                </div>
            </div>

        </div>
    </div>

    <!--Add & Cancel Button-->

    <div class="p-grid p-mt-3 p-pb-2">
        <div class="p-col-6 p-text-left">
            <button (click)="navigateToUserManagement('cancel')" class="p-button-danger p-button-sm" pButton pRipple
                    label="Cancel"></button>
        </div>
        <div class="p-col-6 p-text-right">
            <button (click)="createUserWithBasicDetails()" class="p-button-secondary p-button-sm" pButton pRipple
                    label="Add"></button>
        </div>
    </div>


</p-dialog>


<!--Add / Edit Business Entity Group-->
<p-dialog [(visible)]="displayBusinessEntityGroupCreation" [header]="'Manage Business Entity Group'"
          [blockScroll]="true" [modal]="true" class="manage-group-dialog"
          [showHeader]="true"
          [closable]="true"
          [closeOnEscape]="false"
          [draggable]="false"
          [breakpoints]="{'1440px': '50%' ,'1024px': '50%','960px': '50%', '640px': '90%'}"
          [style]="{width: '35%'}">


    <div class="p-grid" [formGroup]="businessEntityGroupForm">
        <div class="p-col-12">
            <div class="p-field">
                <small>Group Name *</small>
                <input type="text" class="width-100" placeholder="Group name cannot be Null" formControlName="groupName"
                       pInputText>
            </div>
        </div>

        <div class="p-col-12">
            <div class="p-field">
                <small>Select Companies *</small>
                <p-multiSelect placeholder="Select.." class="multi-select"
                               appendTo="body" styleClass="width-100 multi-select"
                               optionLabel="name"
                               [options]="businessEntities"
                               formControlName="businessEntities"
                               filterBy="name">

                    <ng-template pTemplate="items" let-businessEntity>
                        {{businessEntity?.name}} {{'&nbsp;'}}
                        ({{businessEntity?.businessEntityId}})
                    </ng-template>

                </p-multiSelect>
            </div>
        </div>


    </div>

    <div class="p-grid p-py-3">
        <div class="p-col-6 p-text-left">
            <button type="button" (click)="createBusinessEntityGroupForm(); displayBusinessEntityGroupCreation = false;"
                    pButton
                    pRipple class="p-button-danger p-button-sm" label="Cancel"></button>
        </div>
        <div class="p-col-6 p-text-right">
            <button type="button" (click)="handleBusinessEntityGroup()" pButton pRipple
                    class="p-button-secondary p-button-sm" label="Save"></button>
        </div>
    </div>

</p-dialog>

<!--Add / Edit Domain Group-->
<p-dialog [(visible)]="displayDomainGroupCreation" [header]="'Manage Domain Group'"
          [blockScroll]="true" [modal]="true" class="manage-group-dialog"
          [showHeader]="true"
          [closable]="true"
          [closeOnEscape]="false"
          [draggable]="false"
          [breakpoints]="{'1440px': '50%' ,'1024px': '50%','960px': '50%', '640px': '90%'}"
          [style]="{width: '35%'}">


    <div class="p-grid" [formGroup]="domainGroupForm">
        <div class="p-col-12">
            <div class="p-field">
                <small>Group Name *</small>
                <input type="text" class="width-100" placeholder="Group name cannot be Null"
                       formControlName="domainGroupName"
                       pInputText>
            </div>
        </div>

        <div class="p-col-12">
            <div class="p-field">
                <small>Select Domains *</small>
                <p-multiSelect placeholder="Select.." appendTo="body" [options]="domains"
                               optionLabel="domainName" styleClass="width-100"
                               filterBy="domainName"
                               formControlName="domains">
                    <ng-template pTemplate="items" let-domain>
                        {{domain?.domainName}} {{'&nbsp;'}} ({{domain?.domainId}})
                    </ng-template>
                </p-multiSelect>
            </div>
        </div>


    </div>

    <div class="p-grid p-py-3">
        <div class="p-col-6 p-text-left">
            <button type="button" (click)="createDomainGroupForm(); displayDomainGroupCreation = false;"
                    pButton
                    pRipple class="p-button-danger p-button-sm" label="Cancel"></button>
        </div>
        <div class="p-col-6 p-text-right">
            <button type="button" (click)="handleDomainGroup()" pButton pRipple class="p-button-secondary p-button-sm"
                    label="Save"></button>
        </div>
    </div>

</p-dialog>

<div class="p-mt-3">
    <p-breadcrumb [home]="home" [model]="breadcrumbMenuModel"></p-breadcrumb>

    <div class="p-mt-4 card p-shadow-4">

        <!--Heading-->
        <div class="p-grid divider-bottom p-ai-center p-jc-center">
            <div class="p-col-12">
                <h5 class="p-text-primary p-m-0">
                    {{mode !== 'add' ? 'Edit User' : 'Add New User Info'}}
                </h5>
            </div>

        </div>

        <!--User Details Form-->
        <div class="p-mt-3">
            <div class="p-grid p-jc-center" [formGroup]="userDetailsForm">

                <!--Save Button-->
                <div class="p-col-12 p-lg-10 p-text-right">
                    <button (click)="updateUserDetails()" class="p-button-secondary p-button-sm" label="Save" pButton
                            pRipple></button>
                </div>
                <div class="p-col-12 p-lg-10">

                    <!--User Information-->
                    <p-fieldset [toggleable]="true">
                        <ng-template pTemplate="header">User Information</ng-template>
                        <div>
                            <div class="p-grid">
                                <div class="p-col-12 p-lg-5">
                                    <div class="p-field">
                                        <small>First Name</small>
                                        <input type="text" pInputText class="width-100" formControlName="firstName">
                                    </div>
                                </div>
                                <div class="p-col-2">

                                </div>

                                <div class="p-col-12 p-lg-5">
                                    <div class="p-field">
                                        <small>Last Name</small>
                                        <input type="text" pInputText class="width-100" formControlName="lastName">
                                    </div>
                                </div>
                            </div>
                            <div class="p-grid">
                                <div class="p-col-12 p-lg-5">
                                    <div class="p-field">
                                        <small>Phone Number</small>
                                        <input type="number" pInputText class="width-100" formControlName="phoneNumber">
                                    </div>
                                </div>
                                <div class="p-col-2">

                                </div>

                            </div>
                        </div>
                    </p-fieldset>

                    <!--Companies Selection / Assign Companies-->

                    <p-fieldset *ngIf="loggedInUser?.showCompanies" [toggleable]="true" styleClass="p-mt-3">
                        <ng-template pTemplate="header">Assign Companies</ng-template>
                        <div>
                            <div class="p-grid">

                                <div class="p-col-12 p-lg-5">
                                    <div class="p-field">
                                        <small>Companies</small>
                                        <p-multiSelect placeholder="Select.." class="multi-select"
                                                       appendTo="body" styleClass="width-100 multi-select"
                                                       (onChange)="userDetailsForm.controls.businessEntityGroup.setValue(null)"
                                                       [options]="businessEntities"
                                                       optionLabel="name"
                                                       filterBy="name"
                                                       formControlName="businessEntities">

                                            <ng-template pTemplate="items" let-businessEntity>
                                                {{businessEntity?.name}} {{'&nbsp;'}}
                                                ({{businessEntity?.businessEntityId}})
                                            </ng-template>

                                        </p-multiSelect>
                                    </div>
                                </div>


                                <div class="p-col-12 p-lg-2 p-d-none p-d-lg-block">
                                    <p-divider layout="vertical">
                                        <b>OR</b>
                                    </p-divider>
                                </div>

                                <div class="p-col-12 p-text-center p-lg-2 p-d-block p-d-lg-none">
                                    <p-divider class="divider-md-screen" layout="horizontal">
                                        <b>OR</b>
                                    </p-divider>
                                </div>

                                <div class="p-col-12 p-lg-5">
                                    <div class="p-field">
                                        <small>Company Group</small>
                                        <p-dropdown #businessEntityGroupDropdown placeholder="Select.." appendTo="body"
                                                    [options]="businessEntitiesGroups"
                                                    optionLabel="groupName"
                                                    (onChange)="userDetailsForm.controls.businessEntities.setValue([])"
                                                    [filter]="true"
                                                    [showClear]="userDetailsForm.value.businessEntityGroup"
                                                    emptyMessage="No Company Group Found"
                                                    styleClass="width-100"
                                                    filterBy="groupName"
                                                    formControlName="businessEntityGroup">

                                            <ng-template pTemplate="items" let-group>
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    <div>
                                                        {{group?.groupName}}
                                                    </div>
                                                    <div>
                                                        <button style="z-index: 10"
                                                                (click)="manageBusinessEntityGroup('edit', group)"
                                                                class="p-button-secondary p-button-text p-button-sm"
                                                                pButton pRipple
                                                                [icon]="'pi pi-pencil'"></button>
                                                    </div>
                                                </div>
                                            </ng-template>

                                            <ng-template pTemplate="footer">
                                                <div (click)="manageBusinessEntityGroup('new'); businessEntityGroupDropdown.hide()"
                                                     class="p-py-3 p-px-2 p-cursor" pRipple>
                                                    Create New
                                                </div>
                                            </ng-template>

                                        </p-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-fieldset>

                    <!--Domains Selection / Assign Domains-->

                    <p-fieldset *ngIf="loggedInUser?.showDomains" [toggleable]="true" styleClass="p-mt-3">
                        <ng-template pTemplate="header">Assign Domains</ng-template>
                        <div>
                            <div class="p-grid">

                                <div class="p-col-12 p-xl-5">
                                    <div class="p-field">
                                        <small>Domains</small>
                                        <p-multiSelect placeholder="Select.." appendTo="body" [options]="domains"
                                                       optionLabel="domainName" styleClass="width-100"
                                                       filterBy="domainName"
                                                       (onChange)="userDetailsForm.controls.domainGroup.setValue(null)"
                                                       formControlName="domains">
                                            <ng-template pTemplate="items" let-domain>
                                                {{domain?.domainName}} {{'&nbsp;'}} ({{domain?.domainId}})
                                            </ng-template>
                                        </p-multiSelect>
                                    </div>
                                </div>


                                <div class="p-col-12 p-lg-2 p-d-none p-d-lg-block">
                                    <p-divider layout="vertical">
                                        <b>OR</b>
                                    </p-divider>
                                </div>

                                <div class="p-col-12 p-text-center p-lg-2 p-d-block p-d-lg-none">
                                    <p-divider class="divider-md-screen" layout="horizontal">
                                        <b>OR</b>
                                    </p-divider>
                                </div>

                                <div class="p-col-12 p-xl-5">
                                    <div class="p-field">
                                        <small>Domain Group</small>
                                        <p-dropdown #domainGroupDropdown
                                                    (onChange)="userDetailsForm.controls.domains.setValue([])"
                                                    [options]="domainGroups" placeholder="Select.." appendTo="body"
                                                    emptyMessage="No Domain Group Found"
                                                    filterBy="domainGroupName"
                                                    [showClear]="userDetailsForm.value.domainGroup"
                                                    [filter]="true"
                                                    optionLabel="domainGroupName"
                                                    styleClass="width-100"
                                                    formControlName="domainGroup">
                                            <ng-template pTemplate="items" let-group>
                                                <div class="p-d-flex p-jc-between p-ai-center">
                                                    <div>
                                                        {{group?.domainGroupName}}
                                                    </div>
                                                    <div>
                                                        <button style="z-index: 10"
                                                                (click)="manageDomainGroup('edit', group)"
                                                                class="p-button-secondary p-button-text p-button-sm"
                                                                pButton pRipple
                                                                [icon]="'pi pi-pencil'"></button>
                                                    </div>
                                                </div>
                                            </ng-template>

                                            <ng-template pTemplate="footer">
                                                <div (click)="manageDomainGroup('new'); domainGroupDropdown.hide()"
                                                     class="p-py-3 p-px-2 p-cursor" pRipple>
                                                    Create New
                                                </div>
                                            </ng-template>
                                        </p-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-fieldset>

                    <!--User Notifications-->
                    <p-fieldset [toggleable]="true" styleClass="p-mt-3">
                        <ng-template pTemplate="header">User Notifications</ng-template>
                        <div>
                            <div class="p-grid p-ai-center">

                                <div class="p-col-12 p-xl-5">
                                    <div class="p-grid">
                                        <div class="p-col-4">
                                            <div class="p-field">
                                                <small>STD Code</small>
                                                <p-dropdown placeholder="Select.." appendTo="body"
                                                            styleClass="width-100"
                                                            [options]="countries"
                                                            optionLabel="stdCode"
                                                            optionValue="stdCode"
                                                            filterBy="stdCode"
                                                            [showClear]="userDetailsForm?.value?.whatsappPhoneStdCode"
                                                            [filter]="true"
                                                            formControlName="whatsappPhoneStdCode"></p-dropdown>
                                            </div>
                                        </div>
                                        <div class="p-col-8">
                                            <div class="p-field">
                                                <small>Whatsapp Number</small>
                                                <input type="number" pInputText class="width-100"
                                                       formControlName="whatsappPhoneNumber">
                                            </div>
                                        </div>
                                        <div class="p-col-12 p-text-right">
                                            <button pButton pRipple
                                                    (click)="isWhatsAppOpted ? whatsAppOptOut(userDetailsForm?.value?.whatsappPhoneNumber, userDetailsForm?.value?.whatsappPhoneStdCode) : whatsAppOptIn(userDetailsForm?.value?.whatsappPhoneNumber, userDetailsForm?.value?.whatsappPhoneStdCode)"
                                                    [label]="isWhatsAppOpted ? 'Opt Out' : 'Opt In'"
                                                    [disabled]="!userDetailsForm?.value?.whatsappPhoneNumber && !userDetailsForm?.value?.whatsappPhoneStdCode "
                                                    class="p-button-sm p-button-secondary"></button>
                                        </div>
                                    </div>
                                </div>


                                <div class="p-col-2">

                                </div>

                                <div class="p-col-12 p-xl-5">
                                    <div class="p-field">
                                        <small>Notification Email</small>
                                        <input type="email" pInputText class="width-100"
                                               formControlName="notificationEmail">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-fieldset>

                    <!--Assigned Roles / Display User Roles-->

                    <p-fieldset [toggleable]="true" styleClass="p-mt-3">
                        <ng-template pTemplate="header">Assigned Roles</ng-template>
                        <div>
                            <div class="p-grid p-ai-start">
                                <div class="p-col-9">
                                    <ul>
                                        <li class="p-py-2" *ngFor="let role of userToManage?.roles">
                                            {{role?.name ? role?.name : '-'}}
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </p-fieldset>

                </div>
            </div>
        </div>

    </div>

</div>
